import { useState, Fragment } from "react";
import { useSelector } from "react-redux";

import PropTypes from "prop-types";

import * as amplitude from "@amplitude/analytics-browser";

import { selectMechanicId } from "../../redux/auth";

import { useCart } from "../../hooks/useCart";

import { logOutOfStock, logSkuOutOfStockQuantity } from "../../services/sku";

import PrimaryButton from "../UI/PrimaryButton/PrimaryButton";
import LoadingOverlay from "../UI/Loading/LoadingOverlay/LoadingOverlay";
import { OutOfStockModal } from "../UI/Modals";

function AddToCartBtn(props) {
  const {
    className,
    id,
    price,
    imageUrl,
    name,
    availableQty,
    qtyToAdd,
    showNotifyMe = true,
  } = props;

  const [outOfStockModal, setOutOfStockModal] = useState({
    isOpen: false,
    message: "",
  });

  const userId = useSelector(selectMechanicId);
  const { skuQuantityIncreasedHandler, isLoading } = useCart();

  function openOutOfStockModalHandler(message = "بنعتذر عن عدم توفر المنتج") {
    setOutOfStockModal({ isOpen: true, message });
  }

  function closeOutOfStockModalHandler() {
    setOutOfStockModal({ isOpen: false, message: "" });
  }

  function addToCartHandler() {
    if (availableQty <= 0) {
      try {
        logOutOfStock(id);
        amplitude.track("order item out of stock", { userId, skuId: id });
      } catch (err) {
        console.error(err);
      }
      openOutOfStockModalHandler();
    } else if (qtyToAdd > availableQty) {
      try {
        logSkuOutOfStockQuantity(id, qtyToAdd);
        amplitude.track("order item quantity out of stock", {
          userId,
          skuId: id,
          quantity: qtyToAdd,
        });
      } catch (err) {
        console.error(err);
      }
      openOutOfStockModalHandler("بنعتذر عن عدم توفر الكمية");
    } else {
      skuQuantityIncreasedHandler(id, price, 0, qtyToAdd);
    }
  }

  return (
    <Fragment>
      <PrimaryButton className={className} onClick={addToCartHandler}>
        أضف الى العربة
      </PrimaryButton>
      {outOfStockModal.isOpen && (
        <OutOfStockModal
          isOpen={outOfStockModal.isOpen}
          onClose={closeOutOfStockModalHandler}
          skuId={id}
          imageUrl={imageUrl}
          name={name}
          price={price}
          message={outOfStockModal.message}
          showNotifyMe={showNotifyMe}
        />
      )}
      {isLoading && <LoadingOverlay />}
    </Fragment>
  );
}

export default AddToCartBtn;

AddToCartBtn.propTypes = {
  className: PropTypes.string,
  id: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  imageUrl: PropTypes.string,
  name: PropTypes.string.isRequired,
  availableQty: PropTypes.number,
  qtyToAdd: PropTypes.number.isRequired,
  showNotifyMe: PropTypes.bool,
};
